import React, { useEffect, useState } from "react";

import { toast } from "react-hot-toast";

import { Add_Restaurant_Payment_Mode_POST, Get_Restaurant_Payment_Mode_Detail_GET, Update_Restaurant_Payment_Mode_PUT } from "api/ApiConst";
import { callGetApi, callPostApi, callPutApi } from "api/ApiCaller";
import { MODAL_LOADER } from "utils/constants";
import { isAlphaNumercSpecialCharSpc, isEmpty } from "utils/TextUtils";

import ModalWrapper from "components/common/ModalWrapper";
import ImageSelector from "components/common/ImageSelector";

const RestaurantPaymentModeAddEdit = ({ show, hideModal, recordID, handleRefresh }) => {
    const defaultRecordObj = {
       title: "",
    };
    const [record, setRecord] = useState(defaultRecordObj);

    useEffect(() => {
        if (recordID) {
            callGetApi(MODAL_LOADER, Get_Restaurant_Payment_Mode_Detail_GET.replaceAll("{recordID}", recordID), {}, (response) => {
                const res = response.responsePacket;
                setRecord(res);
            });
        }
    }, [recordID]);

    //Text Change Event
    const handleTextChange = (e) => {
        const {id,value} = e.target;

        if (id === "title"  && value.length !== 0) {
            if (!isAlphaNumercSpecialCharSpc(value)) {
                return;
            }
        }
        
        setRecord((prev) => ({ ...prev, [e.target.id]: e.target.value }));
    };

    const checkInputValidation = () => {
        if (isEmpty(record.title)) {
            toast.error(`Title name must not be empty`,{id: "toast"});
            return false;
        } 
        else if (record.title.length < 3) {
            toast.error(`Title name must be more than 2 characters`,{id: "toast"});
            return false;
        }
      
        return true;
    };

    //Submit Avatar Form
    const handleSubmit = async () => {
        try {
            if (!checkInputValidation()) {
                return;
            }
            let recordObj = record;
            if (!recordID || recordID === "") {
                callPostApi(MODAL_LOADER, Add_Restaurant_Payment_Mode_POST, recordObj, {}, (response) => {
                    toast.success(response.message, {id: "toast"});
                    hideModal();
                    handleRefresh();
                });
            } else {
                callPutApi(MODAL_LOADER, Update_Restaurant_Payment_Mode_PUT.replaceAll("{recordID}", recordID), recordObj, {}, (response) => {
                    toast.success(response.message, {id: "toast"});
                    hideModal();
                    handleRefresh();
                });
            }
        } catch (error) {
            return;
        }
    };
    return (
        <ModalWrapper show={show} hide={hideModal} backdrop="static"  header={`${recordID ? "Update" : "Add"} Aggregator`} size="ms" handleSubmit={handleSubmit}>
            <div className="form-group row mb-3">
                <div className="col-lg-12 mb-3">
                    <label>Title</label>
                    <input type="text" maxLength={50} className="form-control input-default" id="title" onChange={handleTextChange} value={record.title} />
                </div>
            </div>
        </ModalWrapper>
    );
};

export default RestaurantPaymentModeAddEdit;
